/** What is learned, and how far a learner has got in it: the hub, courses, lessons, the glossary, progress. */
import { baseApi } from '../baseApi';
import type {
  CatalogPage,
  CourseOut,
  Glossary,
  LessonOut,
  LessonProgress,
  ProgressOut,
} from '../types';

export const contentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // The hub: public courses, one entry each, and public lessons that stand alone.
    getCatalog: build.query<
      CatalogPage,
      { lang: string; q?: string | undefined; cursor?: string | undefined }
    >({
      query: (params) => ({ url: '/catalog', params }),
      providesTags: ['Content'],
    }),
    // A course, a lesson and a topic are named by their address (shared/lib/address.ts):
    // `author/course`, `author/course/lesson`. It goes into the path as it is.
    getCourse: build.query<CourseOut, { id: string; lang: string }>({
      query: ({ id, lang }) => ({ url: `/content/${id}`, params: { lang } }),
      providesTags: ['Content'],
    }),
    getLesson: build.query<LessonOut, { id: string; lang: string }>({
      query: ({ id, lang }) => ({ url: `/content/${id}`, params: { lang } }),
      providesTags: ['Content'],
    }),
    getGlossary: build.query<Glossary, string>({
      query: (lang) => ({ url: '/content/glossary', params: { lang } }),
    }),


    // ---- progress
    getCourseProgress: build.query<ProgressOut, string>({
      query: (courseId) => `/progress/${courseId}`,
      providesTags: ['Progress'],
    }),
    // One lesson, wherever it lives: in a course or on its own.
    getLessonProgress: build.query<LessonProgress, string>({
      query: (lessonId) => `/progress/${lessonId}`,
      providesTags: ['Progress'],
    }),
    setPosition: build.mutation<void, { lessonId: string; stepIndex: number }>({
      query: ({ lessonId, stepIndex }) => ({
        url: `/progress/${lessonId}/position`,
        method: 'PUT',
        body: { stepIndex },
      }),
    }),
  }),
});

export const {
  useGetCatalogQuery,
  useGetCourseQuery,
  useGetLessonQuery,
  useGetGlossaryQuery,
  useGetCourseProgressQuery,
  useGetLessonProgressQuery,
} = contentApi;
